"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BrandsPartners() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const partners = [{
    id: 1,
    name: "TechCorp",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/partner_techcorp_logo.png"
  }, {
    id: 2,
    name: "InnovateLabs",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/partner_innovatelabs_logo.png"
  }, {
    id: 3,
    name: "GlobalSystems",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/partner_globalsystems_logo.png"
  }, {
    id: 4,
    name: "FutureTech",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/partner_futuretech_logo.png"
  }, {
    id: 5,
    name: "NextGen",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/partner_nextgen_logo.png"
  }, {
    id: 6,
    name: "Synergy",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/partner_synergy_logo.png"
  }, {
    id: 7,
    name: "Quantum",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/partner_quantum_logo.png"
  }, {
    id: 8,
    name: "Vertex",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/partner_vertex_logo.png"
  }];
  return <section id="brands-partners" ref={sectionRef} className="bg-dark-background py-16 md:py-24">
      <div className="container mx-auto px-6">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-center text-foreground mb-12">
          Brands / Partners
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {partners.map((partner, i) => <div key={partner.id} data-index={i} className={`flex items-center justify-center p-8 bg-secondary/30 rounded-lg border border-border/20 transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <img src={partner.logo} alt={`${partner.name} logo`} className="w-full h-auto max-h-16 object-contain filter grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all duration-[var(--duration-medium)]" />
            </div>)}
        </div>
      </div>
    </section>;
}